
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 45.05 42.49"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{staticClass:"i-a"},[_c('path',{attrs:{"fill":"none","d":"M0 .12h45.05v42.37H0z"}})])]),_c('g',{attrs:{"clip-path":"url(#a)"}},[_c('path',{attrs:{"fill":"#fff","d":"M-.5-.88h46v44h-46z"}}),_c('path',{attrs:{"fill":"#73d6d3","d":"m46.51 47.12-49.01 1v-7l50.01-19z","opacity":".38"}}),_c('path',{attrs:{"fill":"#a3340d","d":"M9.13 46.06a40.9 40.9 0 0 1 3-14.2 23 23 0 0 1 2.39-4.07c-.31.38 3.85 2.59 8.88 2 4.77-.57 8.17-3.61 7.76-3.92a33 33 0 0 1 3.69 4.24A41.4 41.4 0 0 1 41 42.44c.67 2.26-.15 2.55-1.85 3.2a65 65 0 0 1-13.94 2.91 60.2 60.2 0 0 1-13.81.31c-1.48-.22-2.4-.34-2.27-2.8"}}),_c('path',{attrs:{"fill":"#f9ce62","d":"M20.14 2.52a12.6 12.6 0 1 1-11 14 12.61 12.61 0 0 1 11-14"}}),_c('path',{staticStyle:{"isolation":"isolate"},attrs:{"fill":"#fff","d":"M26.61 4.73c3.65 3.2 3.49 9.51-.38 14.09s-10 5.71-13.61 2.52-3.49-9.51.38-14.1 10-5.72 13.61-2.51","opacity":".2"}}),_c('path',{attrs:{"fill":"#d85427","d":"m31.25 25.91-.06-.05ZM23.43 29.8c4.48-.54 7.74-3.26 7.79-3.84-.09.61-3.34 3.29-7.79 3.82-4.71.56-8.66-1.35-8.88-1.9.14.53 4.12 2.49 8.88 1.92"}}),_c('path',{attrs:{"fill":"#d85427","d":"M29.65 47.92S34.74 34 28.12 33C20.2 31.82 16.54 30.37 14 28.52a9 9 0 0 1 .52-.71 23 23 0 0 0-2.39 4.07 40.9 40.9 0 0 0-3 14.2c-.09 2.46.79 2.58 2.23 2.8a60.2 60.2 0 0 0 13.81-.31c2.43-.28 4.69-.64 6.7-1Z"}})])])
          )
        }
      }
    